import KiqOnboardingStep from './KiqOnboardingStep';

export default KiqOnboardingStep;
